<div class="space-y-5" [formGroup]="formGroup">
    <section class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div class="flex flex-col gap-1 md:col-span-2">
            <label for="config-mode">Type</label>
            <p-select inputId="config-mode" [options]="configModes" optionLabel="label" optionValue="value" appendTo="body" formControlName="mode" class="w-full" />
        </div>

        <div class="flex flex-col gap-1">
            <label for="provider-select">Provider</label>
            <p-select
                inputId="provider-select"
                [options]="providers"
                optionLabel="explanation"
                optionValue="code"
                appendTo="body"
                formControlName="providerCode"
                placeholder="Select provider"
                [disabled]="mode === 'edit'"
                [filter]="true"
                filterBy="explanation,code"
                class="w-full"
                [class.ng-dirty]="submitted && formGroup.get('providerCode')?.invalid"
                [class.ng-invalid]="submitted && formGroup.get('providerCode')?.invalid"
            />
            @if (submitted && formGroup.get('providerCode')?.hasError('required')) {
                <small class="text-red-500">Provider is required.</small>
            }
        </div>

        <div class="flex flex-col gap-1">
            <label for="airline-select">Airline</label>
            <p-select
                inputId="airline-select"
                [options]="airlines"
                optionLabel="code"
                optionValue="code"
                appendTo="body"
                formControlName="airlineCode"
                placeholder="Select airline"
                class="w-full"
                [filter]="true"
                filterBy="name,code"
                [showClear]="!isBundleContent"
                [class.ng-dirty]="submitted && formGroup.get('airlineCode')?.invalid"
                [class.ng-invalid]="submitted && formGroup.get('airlineCode')?.invalid"
            />
            @if (submitted && formGroup.get('airlineCode')?.hasError('required')) {
                <small class="text-red-500">Airline is required for bundle content.</small>
            }
        </div>

        <div class="flex flex-col gap-1">
            <label for="faretype-select">Fare Package</label>
            <p-autoComplete
                inputId="faretype-select"
                formControlName="fareTypeName"
                [suggestions]="filteredFareTypeNames"
                (completeMethod)="searchFareTypes($event)"
                [dropdown]="true"
                [forceSelection]="false"
                appendTo="body"
                placeholder="All packages or type a package name"
                [disabled]="!formGroup.get('providerCode')?.value || mode === 'edit'"
                styleClass="w-full"
                inputStyleClass="w-full"
                class="w-full"
                [class.ng-dirty]="submitted && formGroup.get('fareTypeName')?.invalid"
                [class.ng-invalid]="submitted && formGroup.get('fareTypeName')?.invalid"
            />
            @if (submitted && formGroup.get('fareTypeName')?.hasError('required')) {
                <small class="text-red-500">Fare package is required for provider service mapping.</small>
            }
        </div>

        <div class="flex flex-col gap-1">
            <label for="category-select">Category</label>
            <p-select
                inputId="category-select"
                [options]="categories"
                appendTo="body"
                formControlName="categoryName"
                placeholder="Category"
                [filter]="true"
                class="w-full"
                [class.ng-dirty]="submitted && formGroup.get('categoryName')?.invalid"
                [class.ng-invalid]="submitted && formGroup.get('categoryName')?.invalid"
            />
            @if (submitted && formGroup.get('categoryName')?.hasError('required')) {
                <small class="text-red-500">Category is required.</small>
            }
        </div>
    </section>

    <section class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div class="flex flex-col gap-1">
            <label for="amount">Amount</label>
            <p-inputNumber inputId="amount" formControlName="amount" [min]="0" [useGrouping]="false" placeholder="8" class="w-full" />
        </div>
        <div class="flex flex-col gap-1">
            <label for="unit">Unit</label>
            <p-select inputId="unit" [options]="unitOptions" appendTo="body" formControlName="unit" placeholder="Unit" class="w-full" />
        </div>
    </section>

    <section class="grid grid-cols-1 md:grid-cols-2 gap-3" formGroupName="titlesByLanguage">
        <div class="flex flex-col gap-1">
            <label for="title-en">EN</label>
            <input id="title-en" pInputText formControlName="EN" placeholder="8 kg cabin baggage" maxlength="255" class="w-full" />
            @if (submitted && formGroup.get('titlesByLanguage.EN')?.hasError('required')) {
                <small class="text-red-500">EN text is required.</small>
            }
        </div>
        <div class="flex flex-col gap-1">
            <label for="title-de">DE</label>
            <input id="title-de" pInputText formControlName="DE" placeholder="DE text" maxlength="255" class="w-full" />
        </div>
        <div class="flex flex-col gap-1">
            <label for="title-tr">TR</label>
            <input id="title-tr" pInputText formControlName="TR" placeholder="TR text" maxlength="255" class="w-full" />
        </div>
        <div class="flex flex-col gap-1">
            <label for="title-nl">NL</label>
            <input id="title-nl" pInputText formControlName="NL" placeholder="NL text" maxlength="255" class="w-full" />
        </div>
    </section>

    <section class="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2 border-t border-surface-200">
        @if (!isBundleContent) {
            <div class="flex flex-col gap-1 md:col-span-2">
                <label for="ancillary-key">Service Key</label>
                <input
                    id="ancillary-key"
                    pInputText
                    formControlName="ancillaryKey"
                    placeholder="Provider service key"
                    maxlength="255"
                    class="w-full"
                    [class.ng-dirty]="submitted && formGroup.get('ancillaryKey')?.invalid"
                    [class.ng-invalid]="submitted && formGroup.get('ancillaryKey')?.invalid"
                />
                @if (submitted && formGroup.get('ancillaryKey')?.hasError('required')) {
                    <small class="text-red-500">Service key is required for provider service mapping.</small>
                }
            </div>
        }

        <div class="flex flex-col gap-1">
            <label for="status-select">Status</label>
            <p-select inputId="status-select" [options]="statusOptions" appendTo="body" formControlName="status" placeholder="Status" class="w-full" />
        </div>

        <div class="flex flex-col gap-1">
            <label for="priority-order">Priority</label>
            <input id="priority-order" type="number" pInputText formControlName="priorityOrder" placeholder="Auto" min="1" max="100" class="w-full" />
        </div>

        <div class="flex items-center gap-2 md:col-span-2">
            <p-checkbox class="leading-none" inputId="mandatory-selection" formControlName="mandatorySelection" [binary]="true" />
            <label for="mandatory-selection">Mandatory Selection</label>
        </div>
    </section>

    <div class="flex justify-between pt-2">
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="onCancel()"></p-button>
        <p-button [label]="mode === 'add' ? 'Add New' : 'Save'" (click)="onSave()"></p-button>
    </div>
</div>
